import { lazy, Suspense } from 'react';
import Navbar from '@/components/Navbar';
import HeroSection from '@/components/HeroSection';
import LazyLoad from '@/components/LazyLoad';
const ProductSelector = lazy(() => import('@/components/ProductSelector'));
const PricingSection = lazy(() => import('@/components/PricingSection'));
const StatusSection = lazy(() => import('@/components/StatusSection'));
import Footer from '@/components/Footer';

const Index = () => {
  return (
    <div className="min-h-screen relative">
      <Navbar />
      <main className="relative z-10">
        <HeroSection />
        <LazyLoad>
          <Suspense fallback={<div className="h-96 w-full flex items-center justify-center"><div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>}>
            <ProductSelector />
          </Suspense>
        </LazyLoad>
        <LazyLoad>
          <Suspense fallback={<div className="h-96 w-full flex items-center justify-center"><div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>}>
            <PricingSection />
          </Suspense>
        </LazyLoad>
        <LazyLoad>
          <Suspense fallback={<div className="h-96 w-full flex items-center justify-center"><div className="w-8 h-8 rounded-full border-2 border-primary border-t-transparent animate-spin" /></div>}>
            <StatusSection />
          </Suspense>
        </LazyLoad>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
